var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlagInt = function SvgFlagInt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1F3481",
    d: "M0 0h24v16H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EAEAEA",
    d: "M12 13.25a5.25 5.25 0 1 0 0-10.5 5.25 5.25 0 0 0 0 10.5zM6.75 8h10.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EAEAEA",
    d: "M12 13.108c1.208 0 2.188-2.287 2.188-5.108 0-2.82-.98-5.107-2.188-5.107-1.208 0-2.188 2.286-2.188 5.107s.98 5.108 2.188 5.108z"
  })));
};
export { SvgFlagInt as ReactComponent };
export default __webpack_public_path__ + "flag-int.d74396bd8b6f2b21c11f52903a1a05b9.svg";